// extracted by mini-css-extract-plugin
module.exports = {"title-container":"SectionHeader_title-container__F1nJv","title":"SectionHeader_title__2Q_sb"};